import React, { Component } from "react";
import { Link } from "react-router-dom";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import "./styles/WallSidebar.css";
import { connect } from "react-redux";
import * as actions from "../redux/actions/marketstoreListActions";
import { Translate, I18n } from "react-redux-i18n";

function getInitial(name) {
  return (name || "")
    .replace(/\s+/, " ")
    .split(" ")
    .slice(0, 2)
    .map((v) => v && v[0].toUpperCase())
    .join("");
}

function StoreItem({ item }) {
  return (
    <Link to={`/marketstore/show/${item.Id}`} className="wall-store-item">
      {item.Logo ? (
        <img src={item.Logo} className="wall-store-avatar" alt={item.Name} />
      ) : (
        <span className="wall-store-initials">{getInitial(item.Name)}</span>
      )}
      <span className="wall-store-name">{item.Name}</span>
    </Link>
  );
}

class WallStores extends Component {
  componentDidMount() {
    if (this.props.marketstoreList.length === 0) {
      this.fetchMarketStoreList();
    }
  }

  fetchMarketStoreList = async () => {
    try {
      await this.props
        .LoadMarketStores(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    return (
      <div className="wall-sidebar-card">
        <div className="wall-sidebar-card-header">
          <Translate value="marketstores_title" />
        </div>
        <div className="wall-sidebar-card-body">
          {this.props.marketstoreList.map((item) => (
            <StoreItem item={item} key={item.Id} />
          ))}
        </div>
      </div>
    );
  }
}

function mapStateToProps(reducers) {
  return {
    user_id: reducers.session.auth.id,
    token: reducers.session.auth.access_token,
    error: reducers.marketstoreList.error,
    loading: reducers.marketstoreList.loading,
    marketstoreList: reducers.marketstoreList.list,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadMarketStores: (user_id, token) =>
    dispatch(actions.loadList({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(WallStores);
